var render, staticRenderFns
import script from "./DialogDrag.vue?vue&type=script&lang=js"
export * from "./DialogDrag.vue?vue&type=script&lang=js"
import style0 from "./DialogDrag.vue?vue&type=style&index=0&id=73324a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports